// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#outside-navbar-nav .nav-link {
  padding: 10px;
}

.carousel-item {
  align-items: center;
  justify-content: center;
}
.carousel-item .item {
  color: white;
  padding: 60px 100px;
  max-width: 800px;
  text-align: center;
  margin: 0 auto;
}
@media only screen and (max-width: 600px) {
  .carousel-item .item {
    padding: 40px;
  }
  .carousel-item h3 {
    font-size: 18px;
  }
}

.card-heading-trio {
  font-feature-settings: "smcp";
  font-variant: small-caps;
  font-size: 1.5rem;
  text-align: center;
  color: rgba(59, 126, 161, 1);
}

.card-heading {
  font-feature-settings: "smcp";
  font-variant: small-caps;
  font-size: 1.5rem;
  color: rgba(59, 126, 161, 1);
}

.card-heading-bottom {
  font-feature-settings: "smcp";
  font-variant: small-caps;
  font-size: 1.8rem;
  text-align: center;
  color: #d0d0d0;
}

.card-text-trio {
  text-align: center;
}

.card-text-bottom {
  text-align: center;
  color: #d0d0d0;
  font-size: 1.25rem;
}

.card-centered-tp-bg {
  align-content: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0);
}

.row-lb-bg {
  background-color: rgba(59, 126, 161, 0.2);
  align-items: center;
}

.row-no-bg {
  align-items: center;
}

.row-bottom {
  background-color: #003262;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  padding: 40px;
}
@media only screen and (max-width: 600px) {
  .row-bottom {
    padding: 20px;
  }
}

.hero-overlay {
  background-color: rgba(0, 50, 98, 0.8);
  padding: 6px 12px 20px;
  max-width: 280px;
}
.hero-heading {
  font-feature-settings: "smcp";
  font-variant: small-caps;
  color: white;
  font-size: 1.7rem;
}
.hero-text {
  color: white;
  font-size: 1.1rem;
  margin-bottom: 5px;
}

.nav-link {
  color: rgba(0, 50, 98, 1);
  font-feature-settings: "smcp";
  font-variant: small-caps;
  font-weight: bold;
}

.nav-bg {
  background-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 0 8px 8px rgba(255, 255, 255, 0.3);
}

.faq-question-link {
  font-weight: bold;
  color: black;
  text-decoration: none;
}

.faq-question-link:hover {
  color: rgba(59, 126, 161, 1);
}

.faq-question {
  border-width: 1px 1px 0px 0px;
  border-color: lightgray;
  border-style: solid;
  padding-top: 10px;
  padding-bottom: 5px;
}

.faq-answer {
  border-width: 1px 0 0px 0;
  border-color: lightgray;
  border-style: solid;
  padding-top: 10px;
  padding-bottom: 5px;
}
.row-faq:first-child .faq-question,
.row-faq:first-child .faq-answer {
  border-top: none;
}

.blog-post {
  border-width: 0px;
  padding: 8px;
  height: 100%;
  margin-top: 1px;
  margin-right: -1px;
  border-radius: 0px;
  outline: 1px solid lightgray;
}

.blog-post-featured {
  border-width: 0px;
  padding: 8px;
  height: 100%;
  font-size: 1.2rem;
}

.blog-link {
  font-weight: bold;
  color: rgba(59, 126, 161, 1);
  text-decoration: none;
  font-size: 1.3em;
}

.blog-link:hover {
  color: black;
}

.blog-post-featured {
  padding: 8px;
  border-width: 0px;
}
.blog-link-featured {
  font-weight: bold;
  color: rgba(59, 126, 161, 1);
  text-decoration: none;
  font-size: 1.6em;
}

.contact-form-width {
  width: 80%;
  min-width: 250px;
  max-width: 500px;
}

.contact-submit {
  display: block;
  padding: 6px 30px;
  font-size: 14px;
  background-color: #4460aa;
  color: #fff;
  border: none;
  font-weight: bold;
}

/* Override button colors! */
.btn-primary,
.btn-primary:active,
.btn-primary:visited {
  background-color: #003262 !important;
  border-color: #003262 !important;
}

.btn-primary:hover {
  background-color: #3b7ea1 !important;
  border-color: #3b7ea1 !important;
}

.btn-outline-primary,
.btn-outline-primary:active,
.btn-outline-primary:visited {
  background-color: white !important;
  border-color: #003262 !important;
  color: #003262;
}

.btn-outline-primary:hover {
  background-color: #003262 !important;
  border-color: #003262 !important;
  color: white;
}

.pricing-card-primary {
  border-color: #003262 !important;
}

.pricing-card-header {
  background-color: #003262 !important;
  border-color: #003262 !important;
  color: white;
}

.calculator-table {
  margin: 20px 0 40px;
  max-width: 1000px;
}
.calculator-table tr:first-child {
  border-top: 1px solid lightgray;
}
.calculator-table td {
  padding: 6px 20px;
}
.calculator-table tr td:first-child {
  font-weight: bold;
}
.calculator-table tr td:nth-child(2) {
  font-size: 0.9em;
}
.calculator-table tr td:last-child {
  color: rgba(59, 126, 161, 1);
  text-align: right;
  width: 200px;
  vertical-align: middle;
}

footer {
  margin: 40px 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
@media only screen and (max-width: 600px) {
  footer {
    justify-content: center;
    flex-direction: column-reverse;
  }
}

/* Stripe CardElement for /payment
https://stripe.com/docs/js/element/the_element_container
*/

.StripeElement {
  /* background-color: #ff0000 !important;
    border-color: #ff0000 !important; */
  border: 1px solid #eee;
  color: white;
  height: 1.6em;
  margin-bottom: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/outside/outside.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,6BAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,6BAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAAwB;EAAxB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6BAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;EAGE,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE;IACE,uBAAuB;IACvB,8BAA8B;EAChC;AACF;;AAEA;;CAEC;;AAED;EACE;uCACqC;EACrC,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["#outside-navbar-nav .nav-link {\r\n  padding: 10px;\r\n}\r\n\r\n.carousel-item {\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.carousel-item .item {\r\n  color: white;\r\n  padding: 60px 100px;\r\n  max-width: 800px;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n}\r\n@media only screen and (max-width: 600px) {\r\n  .carousel-item .item {\r\n    padding: 40px;\r\n  }\r\n  .carousel-item h3 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n.card-heading-trio {\r\n  font-variant: small-caps;\r\n  font-size: 1.5rem;\r\n  text-align: center;\r\n  color: rgba(59, 126, 161, 1);\r\n}\r\n\r\n.card-heading {\r\n  font-variant: small-caps;\r\n  font-size: 1.5rem;\r\n  color: rgba(59, 126, 161, 1);\r\n}\r\n\r\n.card-heading-bottom {\r\n  font-variant: small-caps;\r\n  font-size: 1.8rem;\r\n  text-align: center;\r\n  color: #d0d0d0;\r\n}\r\n\r\n.card-text-trio {\r\n  text-align: center;\r\n}\r\n\r\n.card-text-bottom {\r\n  text-align: center;\r\n  color: #d0d0d0;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.card-centered-tp-bg {\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.row-lb-bg {\r\n  background-color: rgba(59, 126, 161, 0.2);\r\n  align-items: center;\r\n}\r\n\r\n.row-no-bg {\r\n  align-items: center;\r\n}\r\n\r\n.row-bottom {\r\n  background-color: #003262;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 40px;\r\n  padding: 40px;\r\n}\r\n@media only screen and (max-width: 600px) {\r\n  .row-bottom {\r\n    padding: 20px;\r\n  }\r\n}\r\n\r\n.hero-overlay {\r\n  background-color: rgba(0, 50, 98, 0.8);\r\n  padding: 6px 12px 20px;\r\n  max-width: 280px;\r\n}\r\n.hero-heading {\r\n  font-variant: small-caps;\r\n  color: white;\r\n  font-size: 1.7rem;\r\n}\r\n.hero-text {\r\n  color: white;\r\n  font-size: 1.1rem;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.nav-link {\r\n  color: rgba(0, 50, 98, 1);\r\n  font-variant: small-caps;\r\n  font-weight: bold;\r\n}\r\n\r\n.nav-bg {\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n  box-shadow: 0 0 8px 8px rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.faq-question-link {\r\n  font-weight: bold;\r\n  color: black;\r\n  text-decoration: none;\r\n}\r\n\r\n.faq-question-link:hover {\r\n  color: rgba(59, 126, 161, 1);\r\n}\r\n\r\n.faq-question {\r\n  border-width: 1px 1px 0px 0px;\r\n  border-color: lightgray;\r\n  border-style: solid;\r\n  padding-top: 10px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.faq-answer {\r\n  border-width: 1px 0 0px 0;\r\n  border-color: lightgray;\r\n  border-style: solid;\r\n  padding-top: 10px;\r\n  padding-bottom: 5px;\r\n}\r\n.row-faq:first-child .faq-question,\r\n.row-faq:first-child .faq-answer {\r\n  border-top: none;\r\n}\r\n\r\n.blog-post {\r\n  border-width: 0px;\r\n  padding: 8px;\r\n  height: 100%;\r\n  margin-top: 1px;\r\n  margin-right: -1px;\r\n  border-radius: 0px;\r\n  outline: 1px solid lightgray;\r\n}\r\n\r\n.blog-post-featured {\r\n  border-width: 0px;\r\n  padding: 8px;\r\n  height: 100%;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.blog-link {\r\n  font-weight: bold;\r\n  color: rgba(59, 126, 161, 1);\r\n  text-decoration: none;\r\n  font-size: 1.3em;\r\n}\r\n\r\n.blog-link:hover {\r\n  color: black;\r\n}\r\n\r\n.blog-post-featured {\r\n  padding: 8px;\r\n  border-width: 0px;\r\n}\r\n.blog-link-featured {\r\n  font-weight: bold;\r\n  color: rgba(59, 126, 161, 1);\r\n  text-decoration: none;\r\n  font-size: 1.6em;\r\n}\r\n\r\n.contact-form-width {\r\n  width: 80%;\r\n  min-width: 250px;\r\n  max-width: 500px;\r\n}\r\n\r\n.contact-submit {\r\n  display: block;\r\n  padding: 6px 30px;\r\n  font-size: 14px;\r\n  background-color: #4460aa;\r\n  color: #fff;\r\n  border: none;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Override button colors! */\r\n.btn-primary,\r\n.btn-primary:active,\r\n.btn-primary:visited {\r\n  background-color: #003262 !important;\r\n  border-color: #003262 !important;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background-color: #3b7ea1 !important;\r\n  border-color: #3b7ea1 !important;\r\n}\r\n\r\n.btn-outline-primary,\r\n.btn-outline-primary:active,\r\n.btn-outline-primary:visited {\r\n  background-color: white !important;\r\n  border-color: #003262 !important;\r\n  color: #003262;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  background-color: #003262 !important;\r\n  border-color: #003262 !important;\r\n  color: white;\r\n}\r\n\r\n.pricing-card-primary {\r\n  border-color: #003262 !important;\r\n}\r\n\r\n.pricing-card-header {\r\n  background-color: #003262 !important;\r\n  border-color: #003262 !important;\r\n  color: white;\r\n}\r\n\r\n.calculator-table {\r\n  margin: 20px 0 40px;\r\n  max-width: 1000px;\r\n}\r\n.calculator-table tr:first-child {\r\n  border-top: 1px solid lightgray;\r\n}\r\n.calculator-table td {\r\n  padding: 6px 20px;\r\n}\r\n.calculator-table tr td:first-child {\r\n  font-weight: bold;\r\n}\r\n.calculator-table tr td:nth-child(2) {\r\n  font-size: 0.9em;\r\n}\r\n.calculator-table tr td:last-child {\r\n  color: rgba(59, 126, 161, 1);\r\n  text-align: right;\r\n  width: 200px;\r\n  vertical-align: middle;\r\n}\r\n\r\nfooter {\r\n  margin: 40px 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n}\r\n@media only screen and (max-width: 600px) {\r\n  footer {\r\n    justify-content: center;\r\n    flex-direction: column-reverse;\r\n  }\r\n}\r\n\r\n/* Stripe CardElement for /payment\r\nhttps://stripe.com/docs/js/element/the_element_container\r\n*/\r\n\r\n.StripeElement {\r\n  /* background-color: #ff0000 !important;\r\n    border-color: #ff0000 !important; */\r\n  border: 1px solid #eee;\r\n  color: white;\r\n  height: 1.6em;\r\n  margin-bottom: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
